import Vue from 'vue'
import Vuex from 'vuex'
import bookManage from './bookManage'
import user from './user'
import dics from './dics'
import books from './books'
import app from './app'

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		bookManage,
		user,
		dics,
		books,
		app,
	},
	getters: {
		dicList: state => state.dics.dicList,
		bookList: state => state.books.bookList
	}

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js